import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const InvalidTokenErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('token'),
})

export const TgAccountOfUsedTokenSchema = z.object({
  tg_bot_id: z.number(),
  account_id: z.number(),
  account_name: z.string(),
  avatar_url: z.string(),
  owner_name: z.string(),
  access: z.enum(['user', 'request_sent', 'can_request']),
})

export type TgAccountOfUsedToken = z.infer<typeof TgAccountOfUsedTokenSchema>

export const UsedTokenErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('used_token'),
  error_data: z.object({
    account: TgAccountOfUsedTokenSchema,
  }),
})

export const LimitExceededErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('connection_limit_exceeded'),
})

export const ComplianceErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('connection_restricted_compliance'),
})

export const IgAccountListRetrievalSchema = BusinessErrorSchema.extend({
  field: z.literal('ig_account_list_retrieval'),
})

export const IgAuthStateMissingSchema = BusinessErrorSchema.extend({
  field: z.literal('auth_state_missing'),
})

export const IgAccountBindingSchema = BusinessErrorSchema.extend({
  field: z.literal('account_binding'),
})
